import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
    loanAmount: 200000,
    tenureInYears: 7,
    rateOfInterest: 11,
};

// Create a slice
const emiCalculatorSlice = createSlice({
    name: 'emi',
    initialState,
    reducers: {
        setLoanAmount: (state, action) => {
            state.loanAmount = action.payload;
        },
        setTenureInYears: (state, action) => {
            state.tenureInYears = action.payload;
        },
        setRateOfInterest: (state, action) => {
            state.rateOfInterest = action.payload;
        },
    },
});

// Export actions
export const { setLoanAmount, setTenureInYears, setRateOfInterest } = emiCalculatorSlice.actions;

// Export reducer
export default emiCalculatorSlice.reducer;
